module.exports = __webpack_public_path__ + "site/img/sendfilezh.0885f3e1.png";